import {
  Box,
  BoxProps,
  ElementProps,
  factory,
  Factory,
  StylesApiProps,
  useProps,
  useStyles,
} from '../../core';
import classes from './VisuallyHidden.module.css';

export type VisuallyHiddenStylesNames = 'root';

export interface VisuallyHiddenProps
  extends BoxProps, StylesApiProps<VisuallyHiddenFactory>, ElementProps<'span'> {}

export type VisuallyHiddenFactory = Factory<{
  props: VisuallyHiddenProps;
  ref: HTMLSpanElement;
  stylesNames: VisuallyHiddenStylesNames;
}>;

export const VisuallyHidden = factory<VisuallyHiddenFactory>((_props) => {
  const props = useProps('VisuallyHidden', null, _props);
  const { classNames, className, style, styles, unstyled, vars, attributes, ...others } = props;

  const getStyles = useStyles<VisuallyHiddenFactory>({
    name: 'VisuallyHidden',
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    attributes,
  });

  return <Box component="span" {...getStyles('root')} {...others} />;
});

VisuallyHidden.classes = classes;
VisuallyHidden.displayName = '@mantine/core/VisuallyHidden';

export namespace VisuallyHidden {
  export type Props = VisuallyHiddenProps;
}
